import { apiConfig } from "@pjs/user-ui";

apiConfig.policyLink = () => `${window.config.getApiBaseUrl()}SharedMenu/Forwarder?location=PebblePadWebsite&action=GDPR`;
apiConfig.termsLink = () => `${window.config.getApiBaseUrl()}SharedMenu/Forwarder?location=PebblePadWebsite&action=Terms`;
apiConfig.externalServicesLink = () => `${window.config.getApiBaseUrl()}SharedMenu/Forwarder?location=PlusHTML5&action=View&mainType=ExternalServices`;
